'use client';

import {
	Grid,
	SimpleGrid,
	Stack,
} from '@chakra-ui/react';

import { images } from '@/constants/images';
import { AppRoutes } from '@/constants/route';
import { AuthCTA, useAuthStore } from '@/modules/authentication';
import { HomeSectionWrapper } from '@/modules/home/presentation/composites';
import {
	CompanyCardLogo,
	JobCardFeatured,
	SpecialFeatureCard,
	useRemoveJobHandler,
	useSaveJobHandler,
	JobSearchBar,
} from '@/modules/job';
import {
	ContentContainer,
	FullBleedSection,
	SectionContent,
	HeroCarousel,
} from '@/modules/shared';

const MOCKED = {
	id: '',

	companyName: 'Google LLC',
	detailUrl:   '/jobs/new',
	image:       images.mocked.hiring,
	isSaved: 	   false,
	location:    'Bangkok, Thailand',
	salary:      '฿80,000 - ฿120,000',
	title:       'Senior Product Designer',
};

const mockedFeature = {
	image: images.mocked.featured,
	title: 'Remote Work',
};

export const HomeScreen = () => {
	const { isAuthenticated } = useAuthStore();
	const saveJob = useSaveJobHandler();
	const removeJob = useRemoveJobHandler();

	const carouselSlides = [
		{ href: AppRoutes.jobs.featured, image: images.mocked.hiring },
		{ href: AppRoutes.jobs.new, image: images.mocked.featured },
		{ href: AppRoutes.jobs.featured, image: images.mocked.hiring },
		{ href: AppRoutes.jobs.new, image: images.mocked.featured },
		{ href: AppRoutes.jobs.featured, image: images.mocked.hiring },
	];

	return (
		<>
			<FullBleedSection
				bgImage={`url(${images.corporate.hero.src})`}
				bgRepeat="no-repeat"
				bgSize="cover"
			>
				<ContentContainer position="relative" w="100%">
					<Grid gap="lg" gridTemplateColumns={isAuthenticated ? '1fr' : '1fr 300px'} p="lg">
						<HeroCarousel aspectRatio="wide" carouselSlides={carouselSlides} />
						{!isAuthenticated && <AuthCTA alignSelf="center" />}
					</Grid>
					<JobSearchBar
						bottom={-10}
						left="50%"
						position="absolute"
						transform="translateX(-50%)"
						w="80%"
						zIndex={10}
					/>
				</ContentContainer>
			</FullBleedSection>
			<FullBleedSection bgGradient="primary" pb={{ base: 32, md: 48 }} pt={20}>
				<SectionContent as={Stack} gap="2xl">
					<HomeSectionWrapper ctaText="View More" href={AppRoutes.companies.popular} title="Popular Company">
						<SimpleGrid columns={5} gap="sm">
							{Array.from({ length: 10 }).map((_, index) => (
								<CompanyCardLogo image={images.logo.plusUpRecruit} key={`popular-company-${index}`} />
							))}
						</SimpleGrid>
					</HomeSectionWrapper>
					<HomeSectionWrapper ctaText="View More" href={AppRoutes.jobs.popular} title="Popular Jobs">
						<SimpleGrid columns={4} gap="sm">
							{Array.from({ length: 4 }).map((_, index) => (
								<JobCardFeatured
									job={MOCKED}
									key={`popular-job-${index}`}
									onSelect={() => saveJob.execute(MOCKED.id)}
									onUnselect={() => removeJob.execute(MOCKED.id)}
								/>
							))}
						</SimpleGrid>
					</HomeSectionWrapper>
					<HomeSectionWrapper ctaText="View More" href={AppRoutes.jobs.new} title="New Jobs">
						<SimpleGrid columns={4} gap="sm">
							{Array.from({ length: 4 }).map((_, index) => (
								<JobCardFeatured
									job={MOCKED}
									key={`New-job-${index}`}
									onSelect={() => saveJob.execute(MOCKED.id)}
									onUnselect={() => removeJob.execute(MOCKED.id)}
								/>
							))}
						</SimpleGrid>
					</HomeSectionWrapper>
					<HomeSectionWrapper ctaText="View More" href={AppRoutes.jobs.featured} title="Special Features">
						<SimpleGrid columns={6} gap="sm">
							{Array.from({ length: 12 }).map((_, index) => (
								<SpecialFeatureCard key={`special-feature-${index}`} {...mockedFeature} />
							))}
						</SimpleGrid>
					</HomeSectionWrapper>
				</SectionContent>
			</FullBleedSection>
		</>
	);
};
